import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import FieldError from 'components/forms/new/FieldError';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

/**
 * Shared single-line text field for the Special Numbers Add/Edit forms.
 * SpecialNumberNameField and PatternField both render this with a different
 * `name`/`label`/`placeholder`.
 */
const SpecialNumberTextField = ({
    name,
    label,
    placeholder,
    errors,
    touched,
    darkMode,
}) => (
    <FormControl
        isRequired
        isInvalid={!!errors[name] && touched[name]}
        sx={{ margin: '0 !important' }}>
        <Stack
            direction="row"
            spacing={stackSpacing}
            sx={{ ...stackStyling(), ...formInputStyles }}>
            <FormLabel sx={formLabelStyling(darkMode)}>{label}</FormLabel>
            <Field
                name={name}
                render={({ field }) => (
                    <NameField
                        {...field}
                        pl={2}
                        placeholder={placeholder}
                        label={`${label} *`}
                        darkMode={darkMode}
                    />
                )}
            />
        </Stack>
        <FieldError isDrawer={false}>{errors?.[name]}</FieldError>
    </FormControl>
);

export default SpecialNumberTextField;
